import React from "react";
import { EmptyState as SharedEmptyState } from "../../shared/StateMessage";

// The hub's empty states carry a default centered glyph so a "nothing here yet"
// panel reads as an intentional empty, not a load that quietly failed. Callers
// can still pass their own `icon`, or `icon={null}` to opt out. Lives in its own
// module (not the kit barrel) so kit components like Timeline can use it without
// importing the barrel that re-exports them — which would be a circular import.
export const DefaultEmptyIcon = () => (
  <svg
    className="h-8 w-8 text-gray-300 dark:text-gray-600"
    viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
  </svg>
);

export const EmptyState = ({ icon, ...props }) => (
  <SharedEmptyState icon={icon === undefined ? <DefaultEmptyIcon /> : icon} {...props} />
);

export default EmptyState;
